// Gates checkout on the digital supply consent tick.
//
// See snippets/mcs-digital-consent.liquid for why the tick exists. This
// keeps the checkout button shut until it is given, in the cart page and
// the cart drawer alike.
//
// A custom element rather than an inline script on purpose: Dawn replaces
// cart markup by assigning innerHTML when the cart changes, and injected
// <script> tags never run. Custom elements upgrade themselves whenever
// they enter the document, so this survives every re-render.
if (!customElements.get('mcs-digital-consent')) {
  customElements.define(
    'mcs-digital-consent',
    class MCSDigitalConsent extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        if (!this.checkbox) return;
        this.checkbox.addEventListener('change', () => this.sync());
        this.sync();
      }

      // The buttons live outside this element, so find them within
      // whichever cart surface we are inside.
      scope() {
        return this.closest('#main-cart-footer, cart-drawer, .drawer__inner') || document;
      }

      sync() {
        const given = this.checkbox.checked;
        this.classList.toggle('is-pending', !given);

        const scope = this.scope();
        scope.querySelectorAll('[name="checkout"], #checkout, #CartDrawer-Checkout').forEach((button) => {
          // Never re-enable a button something else disabled: an empty
          // cart and the undesigned-line guard both switch it off first.
          if (!given) {
            button.setAttribute('disabled', 'disabled');
            button.dataset.mcsConsentHeld = 'true';
          } else if (button.dataset.mcsConsentHeld === 'true') {
            button.removeAttribute('disabled');
            delete button.dataset.mcsConsentHeld;
          }
        });
      }
    }
  );
}
